
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/podcasts/[uid]/[episodeUid]",
      function () {
        return require("private-next-pages/podcasts/[uid]/[episodeUid].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/podcasts/[uid]/[episodeUid]"])
      });
    }
  